import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import RightArrowIcon from '@/src/components/icons/RightArrowIcon.jsx';
import SentimentDot from '@/src/components/SentimentDot.jsx';
import ProgressBar from '@/src/components/ProgressBar.jsx';
import { InfoIcon } from '@/src/components/icons/InfoIcon.jsx';

const PeopleEngagementTableRow = ({ item, depth = 0, renderChildren }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const hasChildren = item.children && item.children.length > 0;

  const handleToggle = () => {
    if (hasChildren) {
      setIsExpanded(!isExpanded);
    }
  };

  const getSentiment = (percentage) => {
    if (percentage >= 75 && percentage <= 100) return 'completion-very-high';
    if (percentage >= 50 && percentage < 75) return 'completion-high';
    if (percentage >= 25 && percentage < 50) return 'completion-medium';
    if (percentage >= 0 && percentage < 25) return 'completion-low';
  };

  const rowClassName = depth > 0 ? 'nested-row' : '';
  const expandedClassName = isExpanded ? 'row-expanded' : 'row-collapsed';

  return (
    <>
      <tr className={`${rowClassName} ${hasChildren ? expandedClassName : ''}`}>
        <td>
          <div
            style={{ paddingLeft: `${24 + depth * 50}px` }}
            className="flex align-center"
          >
            {hasChildren ? (
              <>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleToggle();
                  }}
                  className="flex flex-align-start table-row-toggle"
                >
                  <div className="m-r-8">
                    <RightArrowIcon className="collapse-caret" />
                  </div>
                  <span className="font-medium row-name-text">{item.name}</span>
                </a>
                <div className="group-tooltip-wrapper">
                  <Button
                    variant="link"
                    aria-label="View child groups"
                    type="button"
                    className="flex flex-align-center m-l-8 btn-last-update-icon"
                  >
                    <InfoIcon />
                  </Button>
                  <div className="group-tooltip-content">
                    <div className="font-size-12 m-b-8">
                      This parent group contains the following child groups:
                    </div>
                    <ul className="font-size-12 m-t-8 m-b-0 p-l-20">
                      {item.children.map((child) => (
                        <li key={child.id}>{child.name}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </>
            ) : (
              <div>
                <div style={{ width: '7px', marginRight: '8px' }}></div>
                <span className="font-medium row-name-text">{item.name}</span>
              </div>
            )}
          </div>
        </td>
        <td>
          <div className="flex align-center">
            <SentimentDot sentiment="readiness" />
            <span className="font-medium m-l-4">{item.readiness}</span>
          </div>
        </td>
        <td>
          <div className="flex align-center">
            <SentimentDot sentiment="communication" />
            <span className="font-medium m-l-4">{item.communication}</span>
          </div>
        </td>
        <td>
          <div className="flex align-center">
            <SentimentDot sentiment="training" />
            <span className="font-medium m-l-4">{item.training}</span>
          </div>
        </td>
        <td>
          <div className="flex align-center">
            <SentimentDot sentiment="sustainment" />
            <span className="font-medium m-l-4">{item.sustainment}</span>
          </div>
        </td>
        <td>
          <span className="font-medium">{item.feedbackForms}</span>
        </td>
        <td>
          <div className="flex flex-col flex-align-start">
            <span className="font-medium font-size-12">
              {item.feedbackEngagement.percentage}% (
              {item.feedbackEngagement.count}/{item.feedbackEngagement.total})
            </span>
            <ProgressBar
              count={item.feedbackEngagement.count}
              total={item.feedbackEngagement.total}
              sentiment={getSentiment(item.feedbackEngagement.percentage)}
            />
          </div>
        </td>
        <td>
          <div className="flex flex-col flex-align-start">
            <span className="font-medium font-size-12">{item.completion}%</span>
            <ProgressBar
              count={item.completion}
              total={100}
              sentiment={getSentiment(item.completion)}
            />
          </div>
        </td>
      </tr>
      {hasChildren && isExpanded && renderChildren(item.children, depth + 1)}
    </>
  );
};

export default PeopleEngagementTableRow;
